/// <reference types="@shopify/polaris-types" />

export function ToggleSection({
  enabled,
  toggling,
  credits,
  onToggle,
}: {
  enabled: boolean;
  toggling: boolean;
  credits: number;
  onToggle: (enabled: boolean) => void;
}) {
  return (
    <s-section>
      <s-stack direction="block" gap="small-100">
        <s-stack direction="inline" gap="small-200" alignItems="center">
          <s-checkbox
            checked={enabled || undefined}
            disabled={toggling || credits === 0 || undefined}
            onChange={(e: Event) =>
              onToggle((e.target as HTMLInputElement).checked)
            }
          />
          <s-text>Habilita Google Autocomplete en tu formulario COD</s-text>
          {toggling && <s-spinner accessibility-label="Guardando…" />}
        </s-stack>
        {credits === 0 && (
          <s-text color="subdued">
            Necesitas créditos para activar esta función.
          </s-text>
        )}
      </s-stack>
    </s-section>
  );
}
